import { store } from "../app/store";
import { setLoader } from "./loader/loaderSlice";

export default function setLoading(isLoading: boolean) {
  store.dispatch(setLoader(isLoading));
}
